// Polyfill for Node.js 14 compatibility: map node: prefix to regular modules
// This MUST run before any other requires, as some dependencies use node:stream which requires Node 16+
if (process.env.NODE_ENV === 'test') {
  // eslint-disable-next-line global-require
  var Module = require('module');
  
  // Patch Module.prototype.require for direct require() calls
  var originalRequire = Module.prototype.require;
  Module.prototype.require = function requirePolyfill(id) {
    // Strip node: prefix if present
    var normalizedId = id;
    if (typeof id === 'string' && id.startsWith('node:')) {
      normalizedId = id.replace(/^node:/, '');
    }
    var result = originalRequire.call(this, normalizedId);
    
    // If jest-resolve was just loaded, patch it immediately
    if (id === 'jest-resolve' && result && result.Resolver) {
      patchJestResolverSync(result.Resolver);
    }
    
    return result;
  };
  
  // Get built-in modules list from Node.js if available, otherwise use a comprehensive list
  var builtinModules;
  try {
    // Node.js 9+ has Module.builtinModules
    if (Module.builtinModules && Array.isArray(Module.builtinModules)) {
      builtinModules = new Set(Module.builtinModules);
    } else {
      // Fallback for older Node.js versions
      builtinModules = new Set([
        'stream', 'util', 'path', 'fs', 'os', 'crypto', 'buffer', 'events',
        'url', 'querystring', 'http', 'https', 'net', 'zlib', 'child_process',
        'cluster', 'dgram', 'dns', 'module', 'process', 'readline', 'repl',
        'string_decoder', 'tls', 'tty', 'vm', 'worker_threads', 'assert',
        'async_hooks', 'console', 'constants', 'domain', 'errors', 'freelist',
        'http2', 'inspector', 'perf_hooks', 'punycode', 'timers', 'trace_events', 'v8', 'wasi'
      ]);
    }
  } catch (e) {
    // Fallback if anything fails
    builtinModules = new Set(['stream', 'util', 'path', 'fs', 'os', 'crypto', 'buffer', 'events']);
  }
  
  // Track patched resolvers to avoid infinite loops
  var patchedResolvers = new WeakSet();
  
  // Function to patch Jest's resolver synchronously
  // eslint-disable-next-line no-inner-declarations
  function patchJestResolverSync(Resolver) {
    if (!Resolver || patchedResolvers.has(Resolver)) {
      return;
    }
    
    // Mark as patched to avoid infinite loops
    patchedResolvers.add(Resolver);
    
    // Patch isCoreModule FIRST - this is critical for Jest to recognize built-ins
    var originalIsCoreModule = Resolver.prototype.isCoreModule;
    if (originalIsCoreModule) {
      // eslint-disable-next-line no-param-reassign
      Resolver.prototype.isCoreModule = function isCoreModulePolyfill(moduleName) {
        var normalizedName = moduleName;
        if (typeof moduleName === 'string' && moduleName.startsWith('node:')) {
          normalizedName = moduleName.replace(/^node:/, '');
        }
        return originalIsCoreModule.call(this, normalizedName);
      };
    }
    
    // Patch resolveModule to handle node: prefix
    var originalResolveModule = Resolver.prototype.resolveModule;
    if (originalResolveModule) {
      // eslint-disable-next-line no-param-reassign
      Resolver.prototype.resolveModule = function resolveModulePolyfill(from, moduleName, options) {
        // Strip node: prefix if present FIRST
        var normalizedName = moduleName;
        if (typeof moduleName === 'string' && moduleName.startsWith('node:')) {
          normalizedName = moduleName.replace(/^node:/, '');
        }
        
        // Check if it's a built-in module FIRST (before any other checks)
        // This is critical - we must return the module name directly for built-ins
        // Jest expects the module name (not a path) for built-in modules
        if (typeof normalizedName === 'string' && builtinModules.has(normalizedName)) {
          return normalizedName;
        }
        
        // Also check using isCoreModule as fallback (in case builtinModules list is incomplete)
        if (this.isCoreModule && typeof normalizedName === 'string' && this.isCoreModule(normalizedName)) {
          return normalizedName;
        }
        
        // Otherwise use the original resolver with normalized name
        return originalResolveModule.call(this, from, normalizedName, options);
      };
    }
    
    // Patch findNodeModule to handle node: prefix (static method)
    // Note: findNodeModule is used to find files, but we need to prevent it from
    // trying to stat built-in modules after we strip the node: prefix
    var originalFindNodeModule = Resolver.findNodeModule;
    if (originalFindNodeModule) {
      // eslint-disable-next-line no-param-reassign
      Resolver.findNodeModule = function findNodeModulePolyfill(path, options) {
        // Strip node: prefix if present
        var normalizedPath = path;
        if (typeof path === 'string' && path.startsWith('node:')) {
          normalizedPath = path.replace(/^node:/, '');
        }
        
        // If it's a built-in module, return null to prevent file system lookup
        // Jest will handle built-in modules through resolveModule instead
        if (typeof normalizedPath === 'string' && builtinModules.has(normalizedPath)) {
          return null;
        }
        
        // Otherwise use the original findNodeModule
        return originalFindNodeModule.call(this, normalizedPath, options);
      };
    }
    
  }
  
  // Function to actually apply the patch to jest-resolve module
  // eslint-disable-next-line no-inner-declarations
  function applyJestResolvePatch() {
    try {
      // eslint-disable-next-line global-require, import/no-extraneous-dependencies
      var jestResolve = require('jest-resolve');
      if (jestResolve && jestResolve.Resolver) {
        patchJestResolverSync(jestResolve.Resolver);
        // Also replace the Resolver export to ensure new instances use patched version
        // This is important because Jest might cache the Resolver class
        if (jestResolve.default && jestResolve.default.Resolver) {
          patchJestResolverSync(jestResolve.default.Resolver);
        }
      }
    } catch (e) {
      // jest-resolve might not be available yet, that's okay
    }
  }
  
  // Try to patch jest-resolve immediately (synchronous)
  applyJestResolvePatch();
  
  // Also try to patch it asynchronously as a fallback
  // Use setImmediate to ensure it runs after Jest initializes
  if (typeof setImmediate !== 'undefined') {
    setImmediate(applyJestResolvePatch);
  } else if (typeof setTimeout !== 'undefined') {
    setTimeout(applyJestResolvePatch, 0);
  }
  
  // Patch Module._resolveFilename for module resolution
  var originalResolveFilename = Module._resolveFilename;
  Module._resolveFilename = function resolveFilenamePolyfill(request, parent, isMain, options) {
    var normalizedRequest = request;
    if (typeof request === 'string' && request.startsWith('node:')) {
      normalizedRequest = request.replace(/^node:/, '');
    }
    return originalResolveFilename.call(this, normalizedRequest, parent, isMain, options);
  };
  
  // Patch Module._load to intercept ALL module loading
  var originalModuleLoad = Module._load;
  Module._load = function loadPolyfill(request, parent, isMain) {
    // Strip node: prefix if present
    var normalizedRequest = request;
    if (typeof request === 'string' && request.startsWith('node:')) {
      normalizedRequest = request.replace(/^node:/, '');
    }
    return originalModuleLoad.call(this, normalizedRequest, parent, isMain);
  };
}

// Support for IE 11
// eslint-disable-next-line global-require
require('babel-polyfill');

// fetch() polyfill for making API calls.
// eslint-disable-next-line global-require
require('whatwg-fetch');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  // eslint-disable-next-line global-require
  require('raf').polyfill(global);
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 1400
// module chunks = 1